import { configureStore } from '@reduxjs/toolkit'
import similarityReducer from './slices/similaritySlice'
import assignmentReducer from './slices/assignmentSlice'

export const store = configureStore({
  reducer: {
    similarity: similarityReducer,
    assignment: assignmentReducer,
  },
}) 